import { Controller } from "@hotwired/stimulus";
import { useClickOutside } from "stimulus-use";

// Connects to data-controller="details"
export default class extends Controller {
  static targets = ["content"];

  connect() {
    useClickOutside(this, { element: this.contentTarget });
  }

  // clickOutside(event) {
  //   event.preventDefault();
  //   if (this.element.hasAttribute("open")) {
  //     this.close();
  //   }
  // }

  close() {
    if (this.element.hasAttribute("open")) {
      this.element.removeAttribute("open");
    }
  }
}
